import {readSmmLanPwaConfig} from './pwa-lan';
import {validateRuntimeStaffAuthSnapshot,verifyStaffPin} from '../../../contracts/staff-auth-v1';

const KEY='mfk.mobile.lan-staff-lkg.v1';
export function rememberLanStaff(snapshot:any){
  try{const auth=validateRuntimeStaffAuthSnapshot(snapshot.localStaffAuth);localStorage.setItem(KEY,JSON.stringify(auth));}catch{/* A partial snapshot cannot erase the last valid local roster. */}
}
export async function localMobileStaff(){
  const config=readSmmLanPwaConfig();if(!config)return null;
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),2200);
  try{
    const response=await globalThis.fetch('http://'+config.host+':'+config.port+'/smm/v1/request',{method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({deviceId:config.deviceId,action:'request',payload:{protocolVersion:1,type:'smm.lan.snapshot.v1',storeId:'MF01'}})});
    if(response.ok)rememberLanStaff(await response.json());
  }catch{/* Local cache remains available during LAN recovery. */}finally{clearTimeout(timer);}
  try{return validateRuntimeStaffAuthSnapshot(JSON.parse(localStorage.getItem(KEY)||'null')).staff;}catch{return null;}
}
export async function verifyLanStaff(identifier:string,pin:string){
  const rows=await localMobileStaff();if(!rows)return null;
  const matches=rows.filter(s=>s.active&&s.role!=='VIEWER'&&(s.staffId===identifier||s.loginId===identifier));
  const staff=matches.length===1?matches[0]:null;
  if(!staff?.pinVerifier||!await verifyStaffPin(pin,staff.pinVerifier))throw Error('PIN 不正確或員工已停用');
  // This is a local UI identity only. It is never accepted by the cloud. The
  // already-paired Pad remains the sole authority for every LAN business command.
  return {staffId:staff.staffId,loginId:staff.loginId,displayName:staff.name,role:staff.role,sessionToken:'LAN.'+Array.from(crypto.getRandomValues(new Uint8Array(16)),b=>b.toString(16).padStart(2,'0')).join('')};
}
